import { render, staticRenderFns } from "./MonthlySocso.vue?vue&type=template&id=89f8150a"
import script from "./MonthlySocso.vue?vue&type=script&lang=js"
export * from "./MonthlySocso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports